module.exports = __webpack_public_path__ + "static/media/than.0e53b46c.svg";